import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ReactLenis, useLenis } from "lenis/react";
import { Toaster } from "sonner";
import PublicLayout from "@/components/public/PublicLayout";
import Home from "@/pages/Home";
import ShoppingPage from "@/pages/ShoppingPage";
import LojasPage from "@/pages/LojasPage";
import CorporatePage from "@/pages/CorporatePage";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function LenisBridge() {
  const lenis = useLenis();
  useEffect(() => {
    window.__lenis = lenis;
  }, [lenis]);
  return null;
}

function App() {
  useEffect(() => {
    document.title = "VM Piabetá Shopping Center";
  }, []);

  return (
    <div className="App grain">
      <ReactLenis root options={{ lerp: 0.08, smoothWheel: true }}>
        <LenisBridge />
        <BrowserRouter>
          <Routes>
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/shopping" element={<ShoppingPage />} />
              <Route path="/lojas" element={<LojasPage />} />
              <Route path="/corporate" element={<CorporatePage />} />
            </Route>
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
          </Routes>
        </BrowserRouter>
        <Toaster theme="dark" position="top-center" richColors />
      </ReactLenis>
    </div>
  );
}

export default App;
